import { useRef, useState } from "react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { CapaMapa } from "../../interfaces/Indicator";
import { API_FILES_BASE_URL } from "../../utils/const";

interface LayersActiveProps {
    capasMapa: CapaMapa[];
    activeCapaIds: number[];
}

const LayersActive = ({ capasMapa, activeCapaIds }: LayersActiveProps) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const capasActivas = capasMapa.filter((c) => activeCapaIds.includes(c.id));

    if (!capasActivas.length) return null;

    return (
        <div
            data-exclude-from-capture="true"
            ref={containerRef}
            className="absolute left-4 bottom-8 lg:bottom-4 z-[1000] min-w-[13.125rem] bg-primary-100 border border-system-light-30 rounded-sm shadow-custom-dual overflow-hidden"
        >
            <button
                type="button"
                onClick={() => setOpen((prev) => !prev)}
                aria-expanded={open}
                className="w-fill flex items-center justify-between gap-1 pb-1 mx-4 border-b border-system-light-30 my-2"
            >
                <span className="text-primary-10 text-tsmall">Capas</span>
                {open
                    ? <MdArrowDropUp />
                    : <MdArrowDropDown />
                }
            </button>
            <div
                className="grid transition-[grid-template-rows] duration-300 ease-in-out pr-4"
                style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
            >
                <div className="overflow-hidden">
                    <div
                        className={` max-h-[9rem]  ${capasActivas.length > 5
                            ? "overflow-y-scroll"
                            : "overflow-y-auto"
                            }`}
                    >
                        {capasActivas.map((capa) => (
                            <div
                                key={capa.id}
                                className="flex items-center gap-2 py-1 pl-4 min-w-0"
                            >
                                <img
                                    src={`${API_FILES_BASE_URL}/${capa.imagen.replace("files/", "")}`}
                                    className="w-[1rem] h-[1rem] shrink-0"
                                />
                                <span
                                    title={capa.nombre}
                                    className="text-system-light-40 text-llarge truncate"
                                >
                                    {capa.nombre}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayersActive;